<template>
  <div v-if="textShow">
    <!-- <p v-if="!value" class="title">说明文本</p>
    <p v-else>{{ value }}</p> -->
    <p class="word-break">{{ textLabel }}</p>
  </div>
</template>

<script>
export default {
  name: 'MyText',
  props: {
    textLabel: {
      type: String,
      default: ''
    },
    textShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.title {
  color: #606266;
}
</style>
